export class RenewalsRateCodeMapItem {
  constructor(public utilityAccountNumber: string, public rateCode: string) {}
}
